//export const server_url = "http://localhost:5000";
export const server_url = "https://personalportfolio2022.herokuapp.com";
